import { useState } from 'react';
import { TaxRate } from '../../types';
import { db } from '../../db';

interface SyncQueueItem {
  type: string;
  action: string;
  data: unknown;
  status: string;
  timestamp: number;
}

export function useTaxRates(addToSyncQueue: (item: SyncQueueItem) => Promise<unknown>) {
  const [taxRates, setTaxRates] = useState<TaxRate[]>([]);
  const [categoryTaxMap, setCategoryTaxMap] = useState<Record<string, number>>({});

  const addTaxRate = async (item: TaxRate) => {
    await db.taxRates.add(item);
    setTaxRates(prev => [...prev, item]);
    await db.syncStack.add({ type: 'taxRate', action: 'create', data: item, status: 'pending', timestamp: Date.now() });
  };

  const updateTaxRate = async (item: TaxRate) => {
    await db.taxRates.put(item);
    setTaxRates(prev => prev.map(i => i.id === item.id ? item : i));
    await addToSyncQueue({ type: 'taxRate', action: 'update', data: item, status: 'pending', timestamp: Date.now() });
  };

  const deleteTaxRate = async (id: number) => {
    await db.taxRates.delete(id);
    setTaxRates(prev => prev.filter(i => i.id !== id));
    await db.syncStack.add({ type: 'taxRate', action: 'delete', data: { id }, status: 'pending', timestamp: Date.now() });
  };

  const updateCategoryTax = async (category: string, taxId: number) => {
    const nextMap = { ...categoryTaxMap, [category]: taxId };
    await db.settings.put({ key: 'categoryTaxMap', value: nextMap });
    await addToSyncQueue({ type: 'setting' as any, action: 'update', data: { key: 'categoryTaxMap', value: nextMap }, status: 'pending', timestamp: Date.now() });
    setCategoryTaxMap(nextMap);
  };

  return {
    taxRates,
    setTaxRates,
    categoryTaxMap,
    setCategoryTaxMap,
    addTaxRate,
    updateTaxRate,
    deleteTaxRate,
    updateCategoryTax,
  };
}
